__turbopack_context__.v({
  "blackOverlay": "NavMenuImageCard-module__8AUNJa__blackOverlay",
  "blurredImage": "NavMenuImageCard-module__8AUNJa__blurredImage",
  "card": "NavMenuImageCard-module__8AUNJa__card",
  "grainOverlay": "NavMenuImageCard-module__8AUNJa__grainOverlay",
  "image": "NavMenuImageCard-module__8AUNJa__image",
  "label": "NavMenuImageCard-module__8AUNJa__label",
});
